import Catalog from "./Catalog";

export default function Tags() {
  return <Catalog initialTab="tags" />;
}
